import React from 'react'

const Content = (props) =>
  <div>
    <h3>Content</h3>
    <hr />
  </div>

export default Content



// WEBPACK FOOTER //
// ./src/pages/Content/Content.js